import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getLasVegasStructuredData() {
  const url = "https://restorehair.com/locations/nevada/las-vegas/";
  const description =
    "Find out about your hair transplant options in Las Vegas with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("las-vegas", url, description),
    locationPageCrumbs(url, "Las Vegas"),
  ];
}
